var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 43H14.5C13.68 43 13 42.32 13 41.5C13 40.68 13.68 40 14.5 40H34.5C40.22 40 43 37.22 43 31.5V17.5C43 11.78 40.22 9 34.5 9H14.5C8.78 9 6 11.78 6 17.5C6 18.32 5.32 19 4.5 19C3.68 19 3 18.32 3 17.5C3 10.2 7.2 6 14.5 6H34.5C41.8 6 46 10.2 46 17.5V31.5C46 38.8 41.8 43 34.5 43Z",
    fill: "#FF9C00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4996 26.2399C22.8196 26.2399 21.1196 25.7199 19.8196 24.6599L13.5596 19.6599C12.9196 19.1399 12.7996 18.1999 13.3196 17.5599C13.8396 16.9199 14.7795 16.7999 15.4195 17.3199L21.6795 22.3199C23.1995 23.5399 25.7795 23.5399 27.2995 22.3199L33.5596 17.3199C34.1996 16.7999 35.1595 16.8999 35.6595 17.5599C36.1795 18.1999 36.0795 19.1599 35.4195 19.6599L29.1595 24.6599C27.8795 25.7199 26.1796 26.2399 24.4996 26.2399Z",
    fill: "#FF9C00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 35H4.5C3.68 35 3 34.32 3 33.5C3 32.68 3.68 32 4.5 32H16.5C17.32 32 18 32.68 18 33.5C18 34.32 17.32 35 16.5 35Z",
    fill: "#FF9C00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 27H4.5C3.68 27 3 26.32 3 25.5C3 24.68 3.68 24 4.5 24H10.5C11.32 24 12 24.68 12 25.5C12 26.32 11.32 27 10.5 27Z",
    fill: "#FF9C00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.8a2282609f662d00515b4212df17ae19.svg";
export { ForwardRef as ReactComponent };